module.exports = "<h2>Check Your Permit</h2>\n\n<ul>\n\t<li>Property Address is correct</li>\n\t<li>Scope of Work is included</li>\n\t<li>Permit Number is visible</li>\n\t<li>City/Couny Name is visible</li>\n\t<li>Permit is final (for Roofing products)</li>\n</ul>\n\n<p class=\"closing-note\">All uploaded documents will be reviewed by our closing team.</p>";


//////////////////
// WEBPACK FOOTER
// ./src/app/appDetail/documents/uploadDocumentsModal/permitChecklistTemplate.html
// module id = 560
// module chunks = 1